export const viewNames = {
  selectMinicipality: "selectMinicipality",
};

export const ITEM_MENU_DEFAULT_STATE = {
  visible: false,
  id: -1,
  visibleTooltip: false,
};

export enum PostalAreasColumns {
  MENU = "more",
  POSTAL_CODE = "postalCode",
  POSTAL_PLACE = "postalPlace",
  COUNTY_CODE = "countyCode",
  COUNTY_NAME = "countyName",
  COUNTRY = "country",
  COUNTRY_CODE = "countryCode",
}